// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"562e97eb","488":"18696137","667":"a8b1fa76"}[chunkId] + ".chunk.js";
};